import { useMutate, UseMutateParams } from './useMutate';
import { httpPut } from '../../components/utils';
import { useCallback } from 'react';

export type UsePutParams<TData, TResponse = unknown, TError = unknown> = Omit<
    UseMutateParams<TData, TResponse, TError>,
    'method'
>;

export const usePut = <TData, TResponse = unknown, TError = unknown>(
    params: UsePutParams<TData, TResponse, TError>
) => {
    // @ts-ignore TODO: currently can't use the generics in `httpPut`, need to be removed when `httpPut` will support generics
    const { mutate, loading, error } = useMutate<TData, TResponse>({ ...params, method: httpPut });

    const put = useCallback((url: string, data: TData) => mutate(url, data), [mutate]);

    return {
        loading,
        error,
        put
    };
};
